<template>
  <div class="sticky-sidebar mt-lg-0 mb-3 px-0">
    <div>
      <div class="w-100 buy-section">
        <div
          v-if="loading"
          class="d-flex justify-content-center flex-column align-items-center w-100"
        >
          <b-skeleton width="200px" height="30px" class="my-1" />
          <b-skeleton width="200px" height="30px" class="my-1" />
          <b-skeleton width="200px" height="30px" class="my-1" />
        </div>
        <div v-else-if="!course.bought">
          <div
            class="w-100 d-flex justify-content-center"
            v-if="!course.bought && !course.can_buy"
          >
            <b-badge
              variant="light-warning"
              class="w-100 font-weight-bolder p-75"
            >
              <h6 class="text-warning mb-0">مهلت ثبت نام به پایان رسیده است</h6>
            </b-badge>
          </div>
          <h4
            class="d-xl-flex d-none justify-content-center my-1"
            v-if="!course.bought && course.can_buy"
          >
            <span
              class="text-danger"
              v-if="finalAmount != 0 && finalAmount != course.amount"
              style="text-decoration: line-through"
            >
              {{ numberWithCommas(course.amount) }}
            </span>
            <span class="text-success"
              >{{
                finalAmount != 0
                  ? numberWithCommas(finalAmount) + " تومان "
                  : "رایگان"
              }}
            </span>
          </h4>
          <div class="d-lg-block d-none">
            <div v-show="!course.bought && course.can_buy && availableAtTimer">
              <div
                class="d-flex justify-content-center align-items-center flex-wrap text-info my-1 font-weight-bold"
              >
                <div class="my-1">زمان باقی مانده تا شروع ثبت نام :</div>
                <timer
                  class="flex-row"
                  color="info"
                  :time="course.available_at"
                  v-model="availableAtTimer"
                />
              </div>
            </div>
            <div
              v-show="
                !course.bought &&
                course.can_buy &&
                !availableAtTimer &&
                unavailableAtTimer
              "
            >
              <div
                class="d-flex justify-content-center align-items-center flex-wrap my-1 font-weight-bold text-danger"
              >
                <div class="my-1">زمان باقی مانده تا پایان مهلت ثبت نام :</div>
                <timer
                  class="flex-row"
                  color="danger"
                  :time="course.unavailable_at"
                  v-model="unavailableAtTimer"
                />
              </div>
            </div>
          </div>

          <div
            class="d-flex justify-content-center w-100"
            v-if="!course.bought && course.can_buy"
          >
            <h5
              class="d-lg-none d-flex justify-content-center my-1 w-50 mx-25"
              v-if="!course.bought && course.can_buy"
            >
              <span
                class="text-danger"
                v-if="finalAmount != 0 && finalAmount != course.amount"
                style="text-decoration: line-through"
              >
                {{ numberWithCommas(course.amount) }}
              </span>
              <span class="text-success"
                >{{
                  finalAmount != 0
                    ? numberWithCommas(finalAmount) + " تومان "
                    : "رایگان"
                }}
              </span>
            </h5>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              block
              class="d-lg-none px-2 d-block w-50 mx-25"
              @click="checkout"
            >
              خرید دوره
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              block
              class="mb-75 d-lg-block d-none"
              @click="checkout"
            >
              خرید دوره
            </b-button>
          </div>
          <div class="d-flex">
            <b-button
              :to="{ name: 'courses' }"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
              class="mt-75 mx-25"
              v-if="
                Object.keys(userData).length &&
                userData.permissions &&
                userData.permissions.permissions &&
                userData.permissions.permissions.length
              "
            >
              برگشت به لیست دوره ها
            </b-button>
            <b-button
              v-b-toggle.sidebar-backdrop
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              block
              class="mt-75 d-lg-none d-flex justify-content-center mx-25"
            >
              مشاهده لیست جلسات
            </b-button>
          </div>

          <hr class="my-2" v-if="!course.bought" />
        </div>
        <div class="w-100" v-else>
          <div>
            <b-badge
              variant="light-success"
              class="w-100 font-weight-bolder p-1 mb-75"
            >
              <h6 class="text-success mb-0">شما دانشجوی این دوره هستید</h6>
            </b-badge>
          </div>
          <div class="d-flex">
            <b-button
              :to="{ name: 'courses' }"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              block
              class="mx-25"
              v-if="
                Object.keys(userData).length &&
                userData.permissions &&
                userData.permissions.permissions &&
                userData.permissions.permissions.length
              "
            >
              برگشت به لیست دوره ها
            </b-button>
            <b-button
              v-b-toggle.sidebar-backdrop
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              block
              class="d-lg-none d-flex justify-content-center mx-25"
            >
              مشاهده لیست جلسات
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-lg-block d-none">
      <div
        v-if="loading"
        class="d-flex justify-content-center flex-column align-items-center"
      >
        <b-skeleton
          width="100%"
          height="50px"
          class="my-1"
          v-for="i in 6"
          :key="i"
        />
      </div>
      <template v-else-if="topics.length">
        <b-form-group v-if="sessions.length > 5">
          <b-form-input v-model="search" placeholder="جستجوی درس ..." />
        </b-form-group>
        <div class="p-md-0 p-1" ref="scroll">
          <app-collapse accordion type="margin">
            <app-collapse-item
              v-for="(topic, topicIndex) in searchableTopics"
              :key="topicIndex"
              :title="topic.title"
              :isVisible="
                showMoreIndexes.includes(topicIndex) ||
                topic.title == 'نتایج جستجو'
              "
              ref="collapse"
            >
              <app-timeline>
                <app-timeline-item
                  :icon="
                    session.access
                      ? session.is_seen
                        ? 'CheckIcon'
                        : 'UnlockIcon'
                      : 'LockIcon'
                  "
                  :variant="session.access ? 'success' : 'danger'"
                  v-for="(session, index) in topic.sessions.slice(
                    0,
                    showMoreIndexes.includes(topicIndex)
                      ? topic.sessions.length
                      : 3
                  )"
                  :key="index"
                  class="pr-50 pb-2 pl-1"
                >
                  <b-button
                    :active="$route.params.session_id == session.id"
                    block
                    :ref="'session-' + session.id"
                    variant="flat-primary"
                    :href="`/courses/${$route.params.id}/sessions/${session.id}`"
                    class="px-50 py-0"
                  >
                    <div
                      class="d-flex flex-row flex-wrap justify-content-between mb-1 mb-sm-0"
                    >
                      <h6 class="my-25 col-8 px-0 text-left">
                        {{ session.name }}
                      </h6>
                      <small class="my-25 col-4 px-0 d-flex flex-wrap">
                        <b-badge
                          variant="info"
                          class="ml-25 mb-25"
                          v-if="
                            session.pivot.status && session.pivot.status == 3
                          "
                          >پیش نمایش</b-badge
                        >
                        <b-badge
                          variant="success"
                          class="ml-25 mb-25"
                          v-if="session.has_exercises"
                          >تمرین</b-badge
                        >
                        <b-badge
                          variant="warning"
                          class="ml-25 mb-25"
                          v-if="session.pamphlet || session.pamphlet_file"
                          >جزوه</b-badge
                        >
                      </small>

                      <small class="text-muted" v-if="session.available_at">
                        {{ calcDate(session.available_at) }}</small
                      >
                    </div>
                    <div
                      v-if="session.brief_description"
                      class="text-muted mt-1"
                      v-html="session.brief_description"
                    ></div>
                  </b-button>
                </app-timeline-item>
                <div
                  v-if="topic.sessions.length > 3"
                  class="w-100 d-flex justify-content-center mt-1 cursor-pointer"
                  @click="
                    showMoreIndexes.includes(topicIndex)
                      ? showMoreIndexes.splice(
                          showMoreIndexes.findIndex(
                            (index) => topicIndex == index
                          ),
                          1
                        )
                      : showMoreIndexes.push(topicIndex)
                  "
                >
                  {{
                    showMoreIndexes.includes(topicIndex) ? "بستن" : "بیشتر ..."
                  }}
                </div>
              </app-timeline>
            </app-collapse-item>
          </app-collapse>
        </div>
      </template>
      <template v-else>
        <b-alert> درسی وجود ندارد </b-alert>
      </template>
    </div>
    <b-sidebar
      id="sidebar-backdrop"
      style="z-index: 999999"
      backdrop-variant="dark"
      backdrop
      shadow
      class="d-block d-xl-none"
    >
      <div class="py-5">
        <div class="px-1">
          <b-button
            v-b-toggle.sidebar-backdrop
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-secondary"
            block
            class="mb-2"
          >
            بستن
          </b-button>
        </div>

        <div
          v-if="loading"
          class="d-flex justify-content-center flex-column align-items-center"
        >
          <b-skeleton
            width="100%"
            height="50px"
            class="my-1"
            v-for="i in 6"
            :key="i"
          />
        </div>
        <template v-else-if="topics.length">
          <b-form-group class="px-1 mb-0" v-if="sessions.length > 5">
            <b-form-input v-model="search" placeholder="جستجوی درس ..." />
          </b-form-group>
          <div class="p-1" ref="scroll">
            <app-collapse accordion type="margin">
              <app-collapse-item
                v-for="(topic, topicIndex) in searchableTopics"
                :key="topicIndex"
                :title="topic.title"
                :isVisible="
                  showMoreIndexes.includes(topicIndex) ||
                  topic.title == 'نتایج جستجو'
                "
                ref="collapse"
              >
                <app-timeline>
                  <app-timeline-item
                    :icon="
                      session.access
                        ? session.is_seen
                          ? 'CheckIcon'
                          : 'UnlockIcon'
                        : 'LockIcon'
                    "
                    :variant="session.access ? 'success' : 'danger'"
                    v-for="(session, index) in topic.sessions.slice(
                      0,
                      showMoreIndexes.includes(topicIndex)
                        ? topic.sessions.length
                        : 3
                    )"
                    :key="index"
                    class="pr-50 pb-2 pl-1 pt-sm-0 pt-2"
                  >
                    <b-button
                      :active="$route.params.session_id == session.id"
                      block
                      :ref="'session-' + session.id"
                      variant="flat-primary"
                      :href="`/courses/${$route.params.id}/sessions/${session.id}`"
                      class="px-50 py-0"
                    >
                      <div
                        class="d-flex flex-row flex-wrap justify-content-between mb-1 mb-sm-0"
                      >
                        <h6 class="my-25 col-8 px-0 text-left">
                          {{ session.name }}
                        </h6>
                        <small class="my-25 col-4 px-0">
                          <b-badge
                            variant="info"
                            class="ml-25 mb-25"
                            v-if="
                              session.pivot.status && session.pivot.status == 3
                            "
                            >پیش نمایش</b-badge
                          >
                          <b-badge
                            variant="success"
                            class="ml-25 mb-25"
                            v-if="session.has_exercises"
                            >تمرین</b-badge
                          >
                          <b-badge
                            variant="warning"
                            class="ml-25 mb-25"
                            v-if="session.pamphlet || session.pamphlet_file"
                            >جزوه</b-badge
                          >
                        </small>

                        <small class="text-muted" v-if="session.available_at">
                          {{ calcDate(session.available_at) }}</small
                        >
                      </div>
                      <div
                        v-if="session.brief_description"
                        class="text-muted mt-1"
                        v-html="session.brief_description"
                      ></div>
                    </b-button>
                  </app-timeline-item>
                  <div
                    v-if="topic.sessions.length > 3"
                    class="w-100 d-flex justify-content-center mt-1 cursor-pointer"
                    @click="
                      showMoreIndexes.includes(topicIndex)
                        ? showMoreIndexes.splice(
                            showMoreIndexes.findIndex(
                              (index) => topicIndex == index
                            ),
                            1
                          )
                        : showMoreIndexes.push(topicIndex)
                    "
                  >
                    {{
                      showMoreIndexes.includes(topicIndex)
                        ? "بستن"
                        : "بیشتر ..."
                    }}
                  </div>
                </app-timeline>
              </app-collapse-item>
            </app-collapse>
          </div>
        </template>
        <template v-else>
          <b-alert> درسی وجود ندارد </b-alert>
        </template>
      </div>
    </b-sidebar>
    <loader :loading="loader" />
  </div>
</template>

<script>
import {
  BImg,
  BAvatar,
  BMedia,
  BButton,
  BCollapse,
  VBToggle,
  BListGroup,
  BListGroupItem,
  BAvatarGroup,
  BBadge,
  VBTooltip,
  BLink,
  BSkeleton,
  BFormGroup,
  BFormInput,
  BAlert,
  BCard,
  BSidebar,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Ripple from "vue-ripple-directive";
import Loader from "@core/components/loader/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Timer from "@core/components/timer/Timer.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BImg,
    BMedia,
    BAvatar,
    BButton,
    BCollapse,
    BListGroup,
    BListGroupItem,
    BAvatarGroup,
    BBadge,
    BLink,
    BSkeleton,
    Loader,
    Timer,
    BFormGroup,
    BFormInput,
    BAlert,
    BCard,
    AppCollapse,
    AppCollapseItem,
    BSidebar,
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip, Ripple },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    topics: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      availableAtTimer: true,
      unavailableAtTimer: true,
      loader: false,
      search: "",
      searchableTopics: [],
      showMoreIndexes: [],
      sessions: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    };
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData || {};
    },
    finalAmount() {
      let finalAmount = 0;
      if (this.course.percentage) {
        finalAmount =
          Number(this.course.amount) -
          (Number(this.course.amount) * Number(this.course.rebate)) / 100;
      } else {
        finalAmount = Number(this.course.amount) - Number(this.course.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  watch: {
    topics(val) {
      this.searchableTopics = [...val];
      val.map((topic) => {
        this.sessions.push(...topic.sessions);
      });
      let topicIndex = this.searchableTopics.findIndex(
        (topic) =>
          topic.sessions.findIndex(
            (session) => session.id == this.$route.params.session_id
          ) > -1
      );
      !this.$route.fullPath.includes('sessions') && (topicIndex = 0);
      this.showMoreIndexes.push(topicIndex);
      if (this.$route.params && this.$route.params.session_id) {
        setTimeout(async () => {
          if (this.$refs["session-" + this.$route.params.session_id][0].$el) {
            let height =
              (await this.$refs[
                "session-" + this.$route.params.session_id
              ][0].$el.getBoundingClientRect().top) -
              this.$refs.scroll.getBoundingClientRect().top;
            window.scrollTo({
              top: height,
              left: 0,
              behavior: "smooth",
            });
          }
        }, 500);
      }
    },
    search(val) {
      if (val) {
        this.$refs.collapse[0].updateVisible(true);
        this.searchableTopics = [
          {
            title: "نتایج جستجو",
            sessions: this.sessions.filter((session) =>
              session.name.includes(this.p2e(val))
            ),
          },
        ];
      } else {
        this.searchableTopics = [...this.topics];
      }
    },
  },
  methods: {
    async checkout() {
      if (Object.keys(this.userData).length) {
        this.loader = true;
        try {
          const { data } = await this.$http.post("/panel/invoices", {
            items: [
              {
                model: {
                  id: this.$route.params.id,
                  type: "course",
                },
              },
            ],
          });
          this.loader = false;

          this.$router.push({
            name: "checkout",
            query: {
              invoice_id: data.data.id,
            },
          });
        } catch (err) {
          this.loader = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: `مشکلی پیش آمده است.`,
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      } else {
        localStorage.setItem("invoice", this.$route.params.id);
        this.$router.push("/login");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              duration: 100000,
              title: `لطفا برای خرید دوره وارد حساب کاربری خود شوید`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
  },
};
</script>
<style scoped>
.ps-customizer-area {
  height: calc(100vh - 210px);
}
</style>
